import { ContextMenuOption } from '../../../models/context-menu-option';
import { NavigationInfo } from '../../../models/navigation-info';
import { GenericTreeNode } from '../../generic-tree/generic-tree-node';

export const DashboardMenu = new GenericTreeNode({
    name: 'Dashboard',
    automationId: 'nav-tree-dashboard',
    navigationInfo: new NavigationInfo({ path: 'reports' }),
    showHeaderButton: true,
    headerButtons: Array<ContextMenuOption>(
        new ContextMenuOption({ name: 'Find in Navigation Tree', iconClass: 'fa-search', iconColor: 'color-blue-01' }),
        new ContextMenuOption({ name: 'Refresh Navigation Tree', iconClass: 'fa-refresh', iconColor: 'color-blue-01' }),
        new ContextMenuOption({ name: 'Hide Navigation Tree', iconClass: 'fa-sitemap', iconColor: 'color-grey-08' })
    )
});
